/**
 * Makes sure that either passing a string or a date turns the return value into a proper Date object.
 *
 * @param {string | Date} date The date to convert
 *
 * @returns {Date} The date as a Date object
 */
export const toDate = (date: string | Date) =>
  typeof date === 'string' ? new Date(date) : date;
